import { createClient, postRequestFactory, SaveOperation } from '@infuse/api/common';
import { OcpiStatus } from '../model';
import { commandPermissions } from './command-permissions';

export interface OverrideOcpiEvseStatusCommand {
  evseId?: number;
  status: OcpiStatus;
}

const client = createClient('/rest/operator-api/charging-stations');

export const overrideOcpiEvseStatus: SaveOperation<OverrideOcpiEvseStatusCommand, void, string> = postRequestFactory<
  OverrideOcpiEvseStatusCommand,
  void,
  string
>(client, {
  pattern: '/{chargingStationId}/override-ocpi-evse-status',
  permissionId: commandPermissions.OVERRIDE_OCPI_EVSE_STATUS
});
